import React from "react"
import "twin.macro"
import { KostraRapportTypeList, KostraRapportType } from "../../data/api"
import Autocomplete from "@material-ui/lab/Autocomplete"

import FormControl from "@material-ui/core/FormControl"

import { Language } from "@nvdb-rapport/shared/src/utils/language"
import * as R from "remeda"
import {
  Field,
  updateValue,
  touchField,
} from "@nvdb-rapport/shared/src/components/formTypes"
import { RemoteData } from "@nvdb-rapport/shared/src/utils/remoteData"
import { TextField } from "@material-ui/core"
import styled from "@emotion/styled"
import tw from "twin.macro"

interface KostraMultipleProps {
  selectedRapportType: Field<KostraRapportType | undefined>
  kostraTyper: RemoteData<Error, KostraRapportTypeList>
  updateSelectedKostraRapportType: React.Dispatch<
    Field<KostraRapportType | undefined>
  >
  language?: Language
}

function getKostraRapportTypeFromName(
  kostraTyper: KostraRapportTypeList,
  name: string
): KostraRapportType | undefined {
  return kostraTyper.find(type => type.navn === name)
}

export default function KostraTypeSelect({
  kostraTyper,
  selectedRapportType,
  updateSelectedKostraRapportType,
  language = "nb_NO",
}: KostraMultipleProps) {
  const validationConditions: ((
    selected: typeof selectedRapportType
  ) => boolean)[] = [
    s => s.value !== undefined,
    s => s.value?.implementert === true,
  ]

  const fieldIsValid = R.allPass(selectedRapportType, validationConditions)

  const kostraOptions =
    kostraTyper.type === "SUCCESS"
      ? kostraTyper.data
      : ([] as KostraRapportType[])

  return (
    <FormControl
      disabled={kostraTyper.type !== "SUCCESS"}
      required
      error={!fieldIsValid}
      variant="filled"
      style={{ width: "100%" }}
    >
      <Autocomplete
        options={R.map(kostraOptions, o => o.navn)}
        value={selectedRapportType.value ? selectedRapportType.value.navn : ""}
        onBlur={() =>
          updateSelectedKostraRapportType(touchField(selectedRapportType))
        }
        onChange={(_: React.ChangeEvent<{}>, value: string | null) => {
          const selectedKostraType = getKostraRapportTypeFromName(
            kostraOptions,
            value ?? ""
          )
          if (kostraTyper.type === "SUCCESS" && selectedKostraType) {
            updateSelectedKostraRapportType(
              updateValue(selectedRapportType, selectedKostraType)
            )
          }
        }}
        renderOption={(option, object) => {
          const opt = getKostraRapportTypeFromName(
            kostraOptions,
            String(option)
          )
          return (
            <>
              {opt && (
                <RenderOption implementert={opt.implementert}>
                  {opt.navn} ({opt.implementert ? opt.id : "Ikke implementert"})
                </RenderOption>
              )}
            </>
          )
        }}
        renderInput={params => {
          return (
            <TextField
              {...params}
              label={
                language === "nb_NO" ? "Velg rapport-type" : "Vel rapport-type"
              }
              variant="filled"
              name="selectedKommuner"
              fullWidth
            />
          )
        }}
      />
      {selectedRapportType.value?.implementert === false && (
        <div tw="text-red-500">
          Denne rapporttypen er foreløpig ikke implementert
        </div>
      )}
    </FormControl>
  )
}
export const RenderOption = styled.div`
  ${({ implementert }: { implementert: boolean }) =>
    implementert ? tw`text-black` : tw`text-gray-500 cursor-not-allowed`};
`
